import { createContext, useContext } from 'react';
import { Jwt } from '@thingslog/repositories';

export interface AuthContextType {
  isAuthenticated: boolean;
  isInitialized: boolean;
  token: string | undefined;
  /** The user the backend session resolved for us. */
  user: Jwt | null;
  login: () => void;
  logout: () => void;
  updateToken: () => Promise<{ success: boolean; token: string | null }>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within a SessionAuthProvider');
  }
  return context;
};
